export interface ContentOption {
  value: string;
  /** Пусто: подпись выбранного видео ещё не известна (его нет в ответе поиска). */
  label: string;
}

/**
 * Опции выбора: ответ поиска плюс все выбранные id. Выбранное видео вне
 * текущей страницы поиска остаётся опцией (с подписью, если её уже видели),
 * поэтому MUI возвращает его в onChange и выбор не теряется при
 * добавлении другого видео (так же ProductsAutocomplete сливает value).
 */
export function mergeContentOptions(
  results: readonly ContentOption[],
  selectedIds: readonly string[],
  knownLabels: ReadonlyMap<string, string>
): ContentOption[] {
  const byId = new Map<string, ContentOption>();
  for (const option of results) byId.set(option.value, option);
  for (const id of selectedIds) {
    if (!byId.has(id)) {
      byId.set(id, { value: id, label: knownLabels.get(id) ?? "" });
    }
  }
  return Array.from(byId.values());
}

/** Выбранные опции в порядке выбора. */
export function selectedContentOptions(
  options: readonly ContentOption[],
  selectedIds: readonly string[]
): ContentOption[] {
  return selectedIds.flatMap((id) => {
    const option = options.find((o) => o.value === id);
    return option ? [option] : [];
  });
}

/**
 * Выбранные id без известной подписи: их подписи кабинет берёт
 * одним запросом списка по ids. Отсортированы, чтобы переменные запроса не
 * зависели от порядка выбора.
 */
export function unlabeledContentIds(
  selectedIds: readonly string[],
  knownLabels: ReadonlyMap<string, string>
): string[] {
  return [...new Set(selectedIds)].filter((id) => !knownLabels.has(id)).sort();
}
